/** Matches API `PreTreatmentDetailApiModel` / `RegPreTreatment` JSON (camelCase). */
export interface IPreTreatmentDetail {
    id: string;
    code: string;
    description: string;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export type PreTreatmentCreatePayload = {
    code: string;
    description: string;
    isActive?: boolean;
};

export type PreTreatmentUpdatePayload = {
    id: string;
    code: string;
    description: string;
};

export const PRE_TREATMENT_CREATE_CONFLICT = {
    deletedRestoreAvailable: "preTreatment.deletedRestoreAvailable",
    duplicateActive: "preTreatment.duplicateActive",
} as const;
